module.exports = __webpack_public_path__ + "img/Fiji.9112eca8.png";